module.exports = "https://neera-retreat.sgp1.cdn.digitaloceanspaces.com/assets/experiences/spaces/experiences_03-neeraspaces.png";